export default "__VITE_ASSET__36b38d8c__"